import './oiLogin.css';
import React, { Component } from 'react';

import axios from 'axios';
import History from '../../History';
import InputMask from 'react-input-mask';

import OiModal from '../oiModal/oiModal';
import OiButton from '../oiButton/oiButton';
import OiLoading from '../oiLoading/oiLoading';

class oiLogin extends Component {
    state = {
        msisdn: null,
        isLoading: false,
        modalIsOpen: false,
        btnIsDisabled: false,
        modal: {
            title: null,
            text: null,
            btn1: null,
            btn2: null,
            event1: null,
            event2: null
        }
    };

    componentDidMount = () => {
        if (sessionStorage.getItem("msisdn") && sessionStorage.getItem("sessionToken")) {
            History.push(`${process.env.PUBLIC_URL}/noticias`);
        }
    }

    manageModal = () => {
        this.setState({ modalIsOpen: !this.state.modalIsOpen });
    }

    inputHandler = (event) => {
        let msisdn = event.target.value;
        msisdn = msisdn.trim();
        sessionStorage.setItem('phoneNumber', msisdn);

        msisdn = msisdn.replace("(", "");
        msisdn = msisdn.replace(")", "");
        msisdn = msisdn.replace(" ", "");
        msisdn = msisdn.replace("-", "");
        msisdn = '55' + msisdn;

        this.setState({ msisdn: msisdn });
    }

    btnClickHandler = (event) => {
        event.preventDefault();

        this.setState({ isLoading: true, btnIsDisabled: true });

        if (this.state.msisdn !== null && this.state.msisdn.length >= 12) {
            this.loginAPIHandler();
        }
        else {
            this.setState({
                modalIsOpen: true,
                isLoading: false,
                btnIsDisabled: false,
                modal: {
                    title: 'Atenção',
                    text: 'Por favor, digite um número Oi Móvel válido.',
                    btn1: 'Entendi',
                    event1: this.manageModal
                }
            });
        }
    }

    loginAPIHandler = () => {
        let self = this;
        let baseUrl = 'https://api.oston.io/clicnoticia/v1';
        const config = { headers: { 'Accept': 'application/json' } };

        //API CHECK BUNDLE
        axios.get(baseUrl + '/auth/' + self.state.msisdn + '/bundle', config)
            .then(response => {
                sessionStorage.setItem('isBundle', 'yes');

                //API CHECK SUBSCRIPTION 
                axios.get(baseUrl + '/auth/' + self.state.msisdn + '/subscription', config)
                    .then(response => {
                        if (response.data.subscription.length > 1) {
                            sessionStorage.setItem('isBundle', 'no');
                        }

                        //API REQUEST PIN 
                        axios.post(baseUrl + '/auth/' + self.state.msisdn + '/request-pin', config)
                            .then(response => {
                                self.setState({ isLoading: false, btnIsDisabled: false });
                                sessionStorage.setItem('msisdn', self.state.msisdn);
                                sessionStorage.setItem('pin', response.data.password);
                                History.push(`${process.env.PUBLIC_URL}/confirmacao`);
                            })
                            .catch(error => {
                                this.setState({
                                    modalIsOpen: true,
                                    isLoading: false,
                                    btnIsDisabled: false,
                                    modal: {
                                        title: 'Atenção',
                                        text: 'Falha no envio do PIN. Por favor, tente novamente.',
                                        btn1: 'Entendi',
                                        event1: this.manageModal
                                    }
                                });
                            });
                    })
                    .catch(error => {
                        this.setState({
                            modalIsOpen: true,
                            isLoading: false,
                            btnIsDisabled: false,
                            modal: {
                                title: 'Atenção',
                                text: 'Falha ao efetuar o login. Por favor, tente novamente.',
                                btn1: 'Entendi',
                                event1: this.manageModal
                            }
                        });
                    });
            })
            .catch(error => {
                sessionStorage.setItem('isBundle', 'no');

                //API CHECK SUBSCRIPTION 
                axios.get(baseUrl + '/auth/' + self.state.msisdn + '/subscription', config)
                    .then(response => {
                        if (response.data.subscription.length < 1) {
                            //API WEB CHECKOUT 
                            axios.post(baseUrl + '/web-checkout/' + self.state.msisdn, config)
                                .then(response => {
                                    window.location = response.data.url;
                                })
                                .catch(error => {
                                    this.setState({
                                        modalIsOpen: true,
                                        isLoading: false,
                                        btnIsDisabled: false,
                                        modal: {
                                            title: 'Atenção',
                                            text: 'Falha no redirecionamento da tela de assinatura. Por favor, tente novamente.',
                                            btn1: 'Entendi',
                                            event1: this.manageModal
                                        }
                                    });
                                });
                        }
                        else {
                            //API REQUEST PIN 
                            axios.post(baseUrl + '/auth/' + self.state.msisdn + '/request-pin', config)
                                .then(response => {
                                    self.setState({ isLoading: false, btnIsDisabled: false });
                                    sessionStorage.setItem('msisdn', self.state.msisdn);
                                    sessionStorage.setItem('pin', response.data.password);
                                    History.push(`${process.env.PUBLIC_URL}/confirmacao`);
                                })
                                .catch(error => {
                                    this.setState({
                                        modalIsOpen: true,
                                        isLoading: false,
                                        btnIsDisabled: false,
                                        modal: {
                                            title: 'Atenção',
                                            text: 'Falha no envio do PIN. Por favor, tente novamente.',
                                            btn1: 'Entendi',
                                            event1: this.manageModal
                                        }
                                    });
                                });
                        }

                    })
                    .catch(error => {
                        this.setState({
                            modalIsOpen: true,
                            isLoading: false,
                            btnIsDisabled: false,
                            modal: {
                                title: 'Atenção',
                                text: 'Falha ao efetuar o login. Por favor, tente novamente.',
                                btn1: 'Entendi',
                                event1: this.manageModal
                            }
                        });
                    });
            });
    }

    render = () => {
        return (
            <div id="oi-login">
                {this.state.isLoading ? <OiLoading /> : ''}
                {this.state.modalIsOpen ? <OiModal modal={this.state.modal} /> : ''}

                <div id="oi-login-text-box">
                    <img id="oi-login-back-image" src={`${process.env.PUBLIC_URL}` + "/imgs/banner-login.jpg"} alt="Banner Login" />

                    <img className="login__info__logo-title" src={`${process.env.PUBLIC_URL + "/imgs/logo-oi-clic-white.png"}`} alt="Logo Full" />

                    <p id="text-1">Seleção de notícias personalizadas de acordo com o seu interesse!</p>
                    <br />
                    <p id="text-3">Entre com seu número Oi.</p>
                </div>

                <form onSubmit={(event) => { this.btnClickHandler(event) }}>

                    <InputMask
                        type="tel"
                        maskChar=" "
                        id="oi-input-login"
                        mask="(99) 99999-9999"
                        placeholder="(DDD) + Telefone"
                        onChange={(event) => { this.inputHandler(event) }}
                    />

                    <OiButton
                        value="continuar" isDisabled={this.state.btnIsDisabled}
                        clickEvent={(event) => { this.btnClickHandler(event) }}
                    />

                </form>

            </div>
        );
    }
};

export default oiLogin;


// WEBPACK FOOTER //
// ./src/components/oiLogin/oiLogin.js